import React, { useEffect } from "react";
import { RouteProps } from "react-router-dom";
import { useAuth } from "src/context/Auth/context";
import { usePermissionPath } from "src/context/PermissionPath/context";
import PageNoPermission from "src/pages/PageNoPermission";

interface IRouteProps extends RouteProps{
    component: React.ComponentType;
	path: string;
	permissionPath?: string;
}

const RoutePermissions: React.FC<IRouteProps> = ({component: Component, path, permissionPath}) => { 
	const { checkIfHasPermission } = useAuth();
	const { changePermissionPath } = usePermissionPath();

	useEffect(() => {
		changePermissionPath(permissionPath);
	}, []);
	
	if(!checkIfHasPermission(permissionPath ?? path))
		return <PageNoPermission />;

	return (
		<Component />
	);
};

export default RoutePermissions;
